
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/auth/login');
  };

  const handleConsultationClick = () => {
    navigate('/consulting');
  };

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-xl flex items-center justify-center">
              <span className="text-lg font-bold text-black">🚗</span>
            </div>
            <div>
              <div className="font-bold text-gray-900 text-lg" style={{ fontFamily: '"Pacifico", serif' }}>
                Georgia Dealer License
              </div>
              <div className="text-xs text-gray-600">Georgia Dealer License Experts</div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link 
              to="/course" 
              className="text-gray-700 hover:text-yellow-600 font-medium transition-colors"
            >
              Course
            </Link>
            <Link 
              to="/resources" 
              className="text-gray-700 hover:text-yellow-600 font-medium transition-colors"
            >
              Resources
            </Link>
            <Link 
              to="/consulting" 
              className="text-gray-700 hover:text-yellow-600 font-medium transition-colors"
            >
              Consulting
            </Link>
            <Link 
              to="/support" 
              className="text-gray-700 hover:text-yellow-600 font-medium transition-colors"
            >
              Support
            </Link>
          </nav>

          {/* Auth Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <button 
              onClick={handleLoginClick}
              className="text-gray-700 hover:text-yellow-600 font-medium transition-colors"
            >
              Login
            </button>
            <button
              onClick={handleConsultationClick}
              className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-black px-4 py-2 rounded-lg font-medium hover:from-yellow-500 hover:to-yellow-600 transition-all whitespace-nowrap"
            >
              Book Consultation
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-8 h-8 flex items-center justify-center text-gray-700 hover:text-gray-900 transition-colors"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <nav className="flex flex-col space-y-4">
              <Link 
                to="/course" 
                className="text-gray-700 hover:text-yellow-600 font-medium transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Course
              </Link>
              <Link 
                to="/resources" 
                className="text-gray-700 hover:text-yellow-600 font-medium transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Resources
              </Link>
              <Link 
                to="/consulting" 
                className="text-gray-700 hover:text-yellow-600 font-medium transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Consulting
              </Link>
              <Link 
                to="/support" 
                className="text-gray-700 hover:text-yellow-600 font-medium transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Support
              </Link>
              <div className="flex flex-col space-y-2 pt-4 border-t">
                <button 
                  onClick={() => {
                    handleLoginClick();
                    setIsMenuOpen(false);
                  }}
                  className="text-left text-gray-700 hover:text-yellow-600 font-medium transition-colors"
                >
                  Login
                </button>
                <button
                  onClick={() => {
                    handleConsultationClick();
                    setIsMenuOpen(false);
                  }}
                  className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-black px-4 py-2 rounded-lg font-medium hover:from-yellow-500 hover:to-yellow-600 transition-all text-center whitespace-nowrap"
                >
                  Book Consultation
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
